module.exports = __webpack_public_path__ + "static/img/live_wechat04.3bafbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live_wechat04.png
// module id = LNzk
// module chunks = 1